import apiUrl from "../../../../../utils/settings";

export const manufactureRoleMapUrl = () => {
  return apiUrl + '/manufacturer-role-map';
};
export const manufactureLeadGeneratedUrl = () => {
  return apiUrl + '/lead-generation';
};